export const getLanguage = (): string | null => {
  return localStorage.getItem('language');
};

export const setLanguage = (lang: string) => {
  localStorage.setItem('language', lang);
};
